import React from 'react';

const ProjectGridContext = React.createContext('project-grid');


export default ProjectGridContext;